import { Endpoints } from "../constants/constants";
import api from "../utils/api";

export type NotificationSettingsType = {
  email: boolean;
  low_balance: boolean;
  min_balance: number;
};

export class NotificationsService {
  static async getSettings(): Promise<NotificationSettingsType> {
    const response = await api.get<{
      success: boolean;
      data: NotificationSettingsType;
    }>(Endpoints.NOTIFICATIONS);

    if (!response.data.success || !response.data.data) {
        throw new Error("Не удалось загрузить настройки оповещений");
    }

    return response.data.data;
  }

  static async updateSettings(
    data: NotificationSettingsType
  ): Promise<{ success: boolean; data: NotificationSettingsType }> {
    const response = await api.post<{
      success: boolean;
      data: NotificationSettingsType;
    }>(Endpoints.NOTIFICATIONS, data);

    return response.data;
  }
}
